import { useState } from "react";
import { toast } from "sonner";
import { BellRing, CheckCircle2 } from "lucide-react";
import { api, formatError } from "@/lib/api";

const INTERESTS = ["Any", "Engineering", "Construction", "Operations", "Environmental & Safety", "Commercial"];
const field = "h-12 w-full border border-slate-300 bg-white px-4 text-[#001870] outline-none focus:border-[#001870]";

export const JobAlerts = () => {
  const [f, setF] = useState({ name: "", email: "", interest: "Any" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/job-alerts", f);
      setDone(true);
      toast.success("You're on the list");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="job-alerts" className="grid gap-8 border-t-4 border-[#AD7F27] bg-white p-6 shadow-[0_10px_30px_rgba(0,24,112,0.08)] md:p-10 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <BellRing className="h-8 w-8 text-[#AD7F27]" />
        <h2 className="font-display mt-4 text-4xl font-bold uppercase leading-none">Get job alerts</h2>
        <p className="mt-3">Leave your email and we'll let you know when new roles open. We only use it for job alerts.</p>
      </div>
      {done ? (
        <div data-testid="job-alerts-success" className="flex items-center gap-3 lg:col-span-7">
          <CheckCircle2 className="h-8 w-8 shrink-0 text-emerald-600" />
          <p className="text-lg font-semibold text-[#001870]">Thanks! We'll email {f.email} when roles open.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
          <label className="text-sm font-medium">Name (optional)<input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="job-alerts-name" className={`mt-1 ${field}`} /></label>
          <label className="text-sm font-medium">Email<input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="job-alerts-email" className={`mt-1 ${field}`} /></label>
          <label className="text-sm font-medium sm:col-span-2">Area of interest
            <select value={f.interest} onChange={(e) => setF({ ...f, interest: e.target.value })} data-testid="job-alerts-interest" className={`mt-1 ${field}`}>
              {INTERESTS.map((i) => <option key={i}>{i}</option>)}
            </select>
          </label>
          <button type="submit" disabled={busy} data-testid="job-alerts-submit" className="h-12 bg-[#001870] px-6 font-semibold uppercase tracking-wide text-white transition-colors hover:bg-[#0a2a9e] disabled:opacity-60 sm:col-span-2">{busy ? "Signing up…" : "Notify me"}</button>
        </form>
      )}
    </div>
  );
};
